import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    description: '7x24小时全网监控，第一时间提供最新网红黑料与娱乐圈爆料资讯。',
    imageUrl: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20background%20with%20subtle%20texture%2C%20minimalist%20editorial%20style%2C%20clean%20composition%2C%20soft%20lighting%2C%20high%20detail%2C%20modern%20aesthetic&width=800&height=600&seq=feature-realtime&orientation=landscape'
  },
  {
    icon: 'ri-shield-check-line',
    title: '严格审核',
    description: '所有爆料内容均经过编辑团队多轮核实，确保信息真实可靠，拒绝虚假传播。',
    imageUrl: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20background%20with%20shield%20concept%2C%20minimalist%20editorial%20style%2C%20clean%20composition%2C%20soft%20lighting%2C%20high%20detail%2C%20modern%20aesthetic&width=800&height=600&seq=feature-review&orientation=landscape'
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    description: '对投稿人信息实行最高级别的保密措施，绝不泄露任何爆料人身份。',
    imageUrl: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20background%20with%20eye%20concept%2C%20minimalist%20editorial%20style%2C%20clean%20composition%2C%20soft%20lighting%2C%20high%20detail%2C%20modern%20aesthetic&width=800&height=600&seq=feature-privacy&orientation=landscape'
  }
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 黑料在线 - 品牌介绍与联系方式';
    const baseUrl = window.location.origin + __BASE_PATH__;
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': `${baseUrl}#organization`,
        name: '黑料在线',
        alternateName: '黑料在线网',
        url: baseUrl,
        description: '国内领先的网红八卦与娱乐黑料资讯平台，每日更新最新网红黑料与娱乐圈爆料。',
        email: 'tips@heiliaozaixian.com',
        sameAs: [
          'https://weibo.com/heiliaozaixian',
          'https://mp.weixin.qq.com/s/heiliaozaixian'
        ]
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${baseUrl}/about`,
        name: '关于我们 - 黑料在线',
        description: '黑料在线品牌介绍、平台特色与联系方式。',
        url: `${baseUrl}/about`,
        isPartOf: { '@id': `${baseUrl}` },
        about: { '@id': `${baseUrl}#organization` }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: `${baseUrl}/` },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: `${baseUrl}/about` }
        ]
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '黑料在线是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '黑料在线是一个聚焦网红八卦、娱乐圈黑料爆料的娱乐资讯平台，每日更新最新网红黑料与娱乐圈爆料，让用户不错过任何热点。'
            }
          },
          {
            '@type': 'Question',
            name: '如何向黑料在线投稿？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '你可以通过发送邮件至 tips@heiliaozaixian.com 进行匿名投稿，我们将严格保护投稿人身份信息。'
            }
          },
          {
            '@type': 'Question',
            name: '黑料在线的爆料内容真实吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '黑料在线的编辑团队对所有爆料内容进行多轮核实，确保信息真实可靠。但部分内容仅供娱乐参考，建议用户理性看待。'
            }
          }
        ]
      }
    ];
    const scripts: HTMLScriptElement[] = [];
    schemas.forEach((s) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(s);
      document.head.appendChild(script);
      scripts.push(script);
    });
    return () => { scripts.forEach((s) => document.head.removeChild(s)); };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 pb-14 md:pb-18 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center"></i>
              <span className="text-foreground-600">关于我们</span>
            </nav>

            <div className="flex flex-col lg:flex-row gap-10 mb-16">
              <div className="lg:w-3/5">
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                  关于<span className="italic text-primary-600">黑料在线</span>
                </h1>
                <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground-700">
                  <p>
                    黑料在线成立于2024年，是国内领先的网红八卦与娱乐黑料资讯平台。
                    我们致力于为用户提供最快速、最真实、最全面的娱乐圈爆料内容。
                  </p>
                  <p>
                    平台汇聚了来自全国各地的资深娱乐记者和匿名爆料人，每日更新超过100条新鲜爆料，
                    涵盖网红八卦、明星黑料、直播翻车、综艺爆料等多个领域。
                  </p>
                  <p>
                    我们的编辑团队拥有丰富的娱乐行业从业经验，坚持"真实第一、速度第二"的原则，
                    在保证信息准确性的前提下，第一时间为用户呈现最劲爆的娱乐资讯。
                  </p>
                  <p>
                    截至2026年7月，黑料在线月活跃用户已突破500万，日均页面浏览量超过2000万次，
                    已成为中文互联网最具影响力的娱乐爆料平台之一。
                  </p>
                </div>
                <div className="flex flex-wrap gap-8 mt-8">
                  <div>
                    <p className="text-3xl font-heading font-black text-foreground-950">500万+</p>
                    <p className="text-sm text-foreground-400 mt-1">月活跃用户</p>
                  </div>
                  <div>
                    <p className="text-3xl font-heading font-black text-foreground-950">100+</p>
                    <p className="text-sm text-foreground-400 mt-1">每日更新爆料</p>
                  </div>
                  <div>
                    <p className="text-3xl font-heading font-black text-foreground-950">50+</p>
                    <p className="text-sm text-foreground-400 mt-1">合作媒体机构</p>
                  </div>
                </div>
              </div>
              <div className="lg:w-2/5">
                <div className="rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20newsroom%20editorial%20office%20with%20multiple%20screens%2C%20team%20collaboration%2C%20warm%20lighting%2C%20professional%20journalism%20environment%2C%20clean%20modern%20workspace%2C%20editorial%20photography%2C%20high%20detail%2C%20cinematic%20mood&width=900&height=700&seq=about-hero-01&orientation=landscape"
                    alt="黑料在线编辑团队"
                    className="w-full h-72 md:h-80 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-center text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-12">
              平台<span className="italic text-primary-600">特色</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature) => (
                <div key={feature.title} className="relative group rounded-xl overflow-hidden aspect-[4/3] cursor-pointer">
                  <img
                    src={feature.imageUrl}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500 flex items-center justify-center mb-4">
                      <i className={`${feature.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
                    </div>
                    <h3 className="text-xl font-heading font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-sm text-white/70 text-center leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="py-14 md:py-18 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-center text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              <span className="italic text-primary-600">联系</span>我们
            </h2>
            <p className="text-center text-sm text-foreground-500 mb-10 max-w-lg mx-auto">
              有任何爆料线索或合作意向，欢迎通过以下方式联系我们
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                <p className="text-sm text-foreground-500">tips@heiliaozaixian.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">微信公众号</h4>
                <p className="text-sm text-foreground-500">搜索"黑料在线"</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-phone-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">商务合作</h4>
                <p className="text-sm text-foreground-500">bd@heiliaozaixian.com</p>
              </div>
            </div>
          </div>
        </section>

        <section id="submit" className="flex flex-col lg:flex-row min-h-[400px]">
          <div className="lg:w-1/2 relative overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=anonymous%20whistleblower%20silhouette%20in%20dark%20room%20with%20warm%20dramatic%20lighting%2C%20secret%20information%20concept%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20clean%20composition%2C%20high%20detail%2C%20cinematic%20mood&width=900&height=600&seq=submit-cta-01&orientation=landscape"
              alt="匿名投稿"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
              <span className="text-xs text-white/60 font-medium uppercase tracking-wider block mb-2">Submit Tips</span>
              <h3 className="text-2xl md:text-4xl font-heading font-black text-white leading-tight">
                匿名<span className="block">安全投稿</span>保护隐私
              </h3>
            </div>
          </div>
          <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-14">
            <div className="max-w-md text-center">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                你有<span className="italic text-primary-600">猛料？</span>
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                我们欢迎任何知情人提供真实爆料线索。投稿即视为同意我们的隐私保护条款，
                我们将严格保密投稿人身份信息。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
                <Link
                  to="/"
                  className="px-8 py-3.5 bg-foreground-950 text-white rounded-full font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  立即投稿爆料
                  <i className="ri-arrow-right-line ml-2 w-4 h-4 flex items-center justify-center inline"></i>
                </Link>
                <span className="text-xs text-foreground-400">或发送邮件至 tips@heiliaozaixian.com</span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}